import { MdWorkOutline } from "react-icons/md";

const thisYear = new Date().getFullYear();
function addProps(dateStart, dateEnd, stackType) {
  return {
    category: "Work",
    dateEnd,
    dateStart,
    icon: <MdWorkOutline />,
    stackType,
  };
}

export const workProjects = [
  {
    name: "Conventional Changelog",
    about:
      "A plugin for providing an NPM package's recommended bump (version) to the release-it library.",
    stack: "JavaScript",
    imgSrc: new URL(
      "../images/projects/work/conventional-changelog.png?as=webp&width=850",
      import.meta.url
    ),
    imgAlt: "Conventional Changelog's screenshot",
    link: "https://github.com/release-it/conventional-changelog#readme-ov-file",
    github: "https://github.com/release-it/conventional-changelog",
    ...addProps(2024, 2025),
  },
  {
    name: "Web Dev Path",
    about:
      "An open-source community where volunteers collaborate remotely on live projects to advance their web development experience.",
    stack: "React",
    imgSrc: new URL(
      "../images/projects/work/webdevpath.png?as=webp&width=850",
      import.meta.url
    ),
    imgAlt: "Web Dev Path's screenshot",
    link: "https://www.webdevpath.co/",
    github: "https://github.com/Web-Dev-Path/web-dev-path",
    ...addProps(2023, 2025),
  },
  {
    name: "Creating NPM Package",
    about:
      "The Creating NPM Package book uses a scalable project to explain the fundamentals of building and managing NPM packages from scratch.",
    stack: "Microsoft Word, Affinity Suite, Microsoft Photos",
    imgSrc: new URL(
      "../images/projects/work/creating-npm-package.webp",
      import.meta.url
    ),
    imgAlt: "The Creating NPM Package book's image",
    link: "https://amzn.to/4b1wvGH",
    ...addProps(2023, 2024, "Press"),
  },
  {
    name: "QuotesDomain",
    about:
      "QuotesDomain contains timeless quotes on various topics. It is an excellent place to get your daily nugget of motivation.",
    stack: "ReactJS, TypeScript, Markdown, Docusaurus, Vercel",
    imgSrc: new URL(
      "../images/projects/work/quotesdomain-homepage.png",
      import.meta.url
    ),
    imgAlt: "The QuotesDomain website's screenshot",
    link: "https://www.quotesdomain.com/",
    ...addProps(2023, thisYear, "Tech"),
  },
  {
    name: "React Image Grid Gallery",
    about:
      "A simple, easy-to-use, and responsive image gallery component for displaying a grid of images in React apps.",
    stack: "ReactJS, TypeScript, Jest, React Testing Library",
    imgSrc: new URL(
      "../images/projects/work/react-image-grid-gallery.webp?width=850",
      import.meta.url
    ),
    imgAlt: "The React Image Grid Gallery project's screenshot",
    link: "https://codesweetly.com/react-image-grid-gallery/#live-demo",
    github: "https://www.npmjs.com/package/react-image-grid-gallery",
    ...addProps(2023, 2024, "Tech"),
  },
  {
    name: "CodeSweetly Sketchbook",
    about:
      "Every top-notch design begins with a sketch. The CodeSweetly Sketchbook is an ideal sketch/note-taking pad for app developers and programmers.",
    stack: "Affinity Suite",
    imgSrc: new URL(
      "../images/projects/work/codesweetly-sketchbook.webp",
      import.meta.url
    ),
    imgAlt: "The CodeSweetly sketchbook's image",
    link: "https://amzn.to/459dQWO",
    ...addProps(2023, 2023, "Press"),
  },
  {
    name: "Visual CSS Grid",
    about:
      "A book filled with beautiful CSS Grid images. Use it as your complete image guide to the CSS Grid layout module.",
    stack: "Microsoft Word, Affinity Suite, Kindle Create",
    imgSrc: new URL(
      "../images/projects/work/visual-css-grid.webp",
      import.meta.url
    ),
    imgAlt: "The Visual CSS Grid book's image",
    link: "https://amzn.to/4216eU6",
    ...addProps(2023, 2023, "Press"),
  },
  {
    name: "The CSS Grid Guidebook",
    about:
      "The CSS Grid Guidebook uses beautiful images and live examples to discuss everything you need to know to use CSS Grid like a pro.",
    stack: "Microsoft Word, Affinity Suite, Kindle Create",
    imgSrc: new URL(
      "../images/projects/work/css-grid-guidebook.webp",
      import.meta.url
    ),
    imgAlt: "The CSS Grid Guidebook's image",
    link: "https://amzn.to/3yQzRdW",
    ...addProps(2023, 2023, "Press"),
  },
  {
    name: "React YouTube Playlist",
    about:
      "An easy-to-use and responsive NPM package for displaying YouTube playlists on a web app. Use it to create a beautiful gallery of YouTube videos on your website.",
    stack: "TypeScript, ReactJS, YouTube API, Jest, React Testing Library",
    imgSrc: new URL(
      "../images/projects/work/react-youtube-playlist.webp",
      import.meta.url
    ),
    imgAlt: "The React YouTube Playlist project's screenshot",
    link: "https://www.npmjs.com/package/@codesweetly/react-youtube-playlist",
    ...addProps(2022, 2024, "Tech"),
  },
  {
    name: "CSS Flexbox",
    about:
      "The CSS Flexbox book uses beautiful images and live examples to discuss everything you need to know to use Flexbox like a pro.",
    stack: "Microsoft Word, Affinity Suite",
    imgSrc: new URL(
      "../images/projects/work/css-flexbox.webp",
      import.meta.url
    ),
    imgAlt: "CSS Flexbox book's image",
    link: "https://amzn.to/3mStkwr",
    ...addProps(2022, 2022, "Press"),
  },
  {
    name: "Visual Flexbox",
    about:
      "A book filled with beautiful CSS Flexbox images. Use it to learn CSS Flexbox quickly in your time.",
    stack: "Affinity Suite",
    imgSrc: new URL(
      "../images/projects/work/visual-flexbox.webp",
      import.meta.url
    ),
    imgAlt: "Visual Flexbox book's image",
    link: "https://amzn.to/3YVRljz",
    ...addProps(2022, 2022, "Press"),
  },
  {
    name: "React Explained Clearly",
    about:
      "The React Explained Clearly book uses scalable projects to explain essential React.js concepts that will set you on a sound footing to become a proficient React developer.",
    stack: "Microsoft Word, Affinity Suite",
    imgSrc: new URL(
      "../images/projects/work/react-explained-clearly.webp",
      import.meta.url
    ),
    imgAlt: "The React Explained Clearly book's image",
    link: "https://amzn.to/3n5pMHt",
    ...addProps(2021, 2021, "Press"),
  },
  {
    name: "CodeSweetly",
    about:
      "CodeSweetly is a tech site developers use to learn web technology topics such as HTML, CSS, JavaScript, and ReactJS.",
    stack: "React, TypeScript, Cloudflare",
    imgSrc: new URL("../images/projects/work/codesweetly.png", import.meta.url),
    imgAlt: "The CodeSweetly website's screenshot",
    link: "https://codesweetly.com/",
    ...addProps(2020, thisYear, "Tech"),
  },
];
